module.exports = __webpack_public_path__ + "img/57.bc0c7707.jpg";